import type {
  CatalogListOptions,
  CatalogPage,
  CatalogRepository,
} from '#/domain/catalog/CatalogRepository'
import type { CatalogLayer } from '#/domain/catalog/CatalogLayer'

export class GetCatalogLayerListUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    options: CatalogListOptions,
    search?: string,
    applicationId?: string,
  ): Promise<CatalogPage<CatalogLayer>> {
    return this.repository.findLayers(options, search, applicationId)
  }
}
